import React, { FC, SyntheticEvent } from "react";
import { COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { usePageDetails } from "../../context";
import { PageDetailsTabs } from "../../context/types";
import { StyledTab, StyledTabs } from "./styled";
import { useTabsAccess } from "./utils";

const Tabs: FC = () => {
  const { selectedTab, setSelectedTab } = usePageDetails();
  const { shouldRenderGeneralTab, shouldRenderTranslationsTab } =
    useTabsAccess();

  const handleTabChange = (_: SyntheticEvent, newTab: PageDetailsTabs) => {
    setSelectedTab(newTab);
  };

  return (
    <StyledTabs
      value={selectedTab}
      onChange={handleTabChange}
      TabIndicatorProps={{
        style: {
          backgroundColor: COLOR_PRIMARY_MAIN,
          height: 2,
        },
      }}
    >
      {shouldRenderGeneralTab && (
        <StyledTab
          id="page-tab-general"
          aria-controls="module-tabpanel-general"
          value={PageDetailsTabs.General}
          disableRipple
          label="General"
        />
      )}
      {shouldRenderTranslationsTab && (
        <StyledTab
          id="page-tab-translations"
          aria-controls="module-tabpanel-translations"
          value={PageDetailsTabs.Translations}
          disableRipple
          label="Translations"
        />
      )}
    </StyledTabs>
  );
};

export default Tabs;
